export default __webpack_public_path__ + "static/stormvc-209d76aae68534da497668b1c240ee09.png";